/**
 * What is in the settings sidebar, and in what order.
 *
 * A sidebar of grouped sections rather than the tab strip it replaces: ten tabs across the
 * top had no room to say what any of them was for, and the two a dispatcher might open sat
 * beside eight that belong to whoever runs the firm. Grouping says which is which without a
 * sentence.
 *
 * `simulation` is not here. It appears only where the server answers for it, which
 * `SettingsArea` discovers by asking — the same way the bar learns whether the settings are
 * this person's at all, and never a role read out of the token. `setup` is in the list of sections, so the route
 * mounts it, and not in a group: it heads the sidebar on its own, for administrators only,
 * discovered the same way.
 */
export const SECTIONS = [
  'setup',
  'dispatch',
  'zones',
  'map',
  'search',
  'places',
  'cancellations',
  'prices',
  'surcharges',
  'duty',
  'fleet',
  'devices',
  'labels',
  'replay',
  'driverApp',
  'branding',
  'telephony',
  'import',
  'simulation',
] as const;

export type Section = (typeof SECTIONS)[number];

export const GROUPS: { label: string; sections: Section[] }[] = [
  { label: 'dispatch', sections: ['dispatch', 'zones', 'map', 'search', 'places', 'cancellations'] },
  { label: 'money', sections: ['prices', 'surcharges', 'duty'] },
  { label: 'people', sections: ['fleet', 'devices', 'labels', 'replay', 'driverApp'] },
  { label: 'firm', sections: ['branding', 'telephony', 'import'] },
];
